import { useRoutes } from 'react-router-dom';
import { routes } from './routes/routes';
import './App.scss';
import React from 'react';
import { useSelector } from 'react-redux';
import { getIsLogged } from '@features/auth/auth.slice';
import { ToastContainer } from 'react-toastify';
import moment from 'moment';
import 'moment/dist/locale/fr';

moment.locale('fr');

const App: React.FC = () => {
    const isLogged = useSelector(getIsLogged);
    const routing = useRoutes(routes(isLogged));

    return (
        <div className="app">
            {routing}
            <ToastContainer />
        </div>
    );
};

export default App;
